exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navDays { position: fixed;bottom: 40px; right: 4px;\n}\n@media (max-width: 480px) {\n.navDays { right: 0; width: 100%\n}\n}\n", ""]);

// exports
